$(document).ready(function(){
    $('.hm_testimonials_carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '80px',
        arrows: true,
        dots: true,
        prevArrow: '<button type="button" class="slick-prev pull-left"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4368 9.44679L17.9785 14.9885L12.4368 20.5303" stroke="#1B599B" stroke-width="2.2988" stroke-linecap="round" stroke-linejoin="round"/> <circle cx="12.5" cy="12.5" r="13.2979" transform="matrix(-1 0 0 1 27 2)" stroke="#1B599B" stroke-width="1.59574"/> </svg></button>',
        nextArrow: '<button type="button" class="slick-next pull-right"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4368 9.44679L17.9785 14.9885L12.4368 20.5303" stroke="#1B599B" stroke-width="2.2988" stroke-linecap="round" stroke-linejoin="round"/> <circle cx="12.5" cy="12.5" r="13.2979" transform="matrix(-1 0 0 1 27 2)" stroke="#1B599B" stroke-width="1.59574"/> </svg></button>',
        responsive: [
            {
              breakpoint: 678,
              settings: {
                slidesToShow: 1,
                centerPadding: '30px'
              }
            }
        ]
      });


      $('.hm_products_carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Arrow_Right.png?v=1731313709'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Arrow_Right.png?v=1731313709'/></button>",
        responsive: [
            {
              breakpoint: 678,
              settings: {
                slidesToShow: 1
              }
            }
        ]
      });

      $('.pr_ingr_carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev pull-left"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4368 9.44679L17.9785 14.9885L12.4368 20.5303" stroke="#1B599B" stroke-width="2.2988" stroke-linecap="round" stroke-linejoin="round"/> <circle cx="12.5" cy="12.5" r="13.2979" transform="matrix(-1 0 0 1 27 2)" stroke="#1B599B" stroke-width="1.59574"/> </svg></button>',
        nextArrow: '<button type="button" class="slick-next pull-right"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4368 9.44679L17.9785 14.9885L12.4368 20.5303" stroke="#1B599B" stroke-width="2.2988" stroke-linecap="round" stroke-linejoin="round"/> <circle cx="12.5" cy="12.5" r="13.2979" transform="matrix(-1 0 0 1 27 2)" stroke="#1B599B" stroke-width="1.59574"/> </svg></button>',
        responsive: [
            {
              breakpoint: 678,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '30px'
              } 
            }
        ]
      });



      $('.bdp_gallery_main').slick({
        dots: false,
        arrows: true, 
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.bdp_gallery_thumb',
        cssEase:'linear'
      });

      $('.bdp_gallery_thumb').slick({
        dots: false,
        arrows: false, 
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_11.png?v=1724852466'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_12.png?v=1724852466'/></button>",
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.bdp_gallery_main',
        cssEase:'linear',
        focusOnSelect: true
      });



      $('.ox_faq_cell').click(function(){
        $(this).toggleClass('active');
        $(this).find('.ox_faq_info').slideToggle();
    });
});